import React, { createContext } from "react";
import { Box, Button, Typography } from "@material-ui/core";
import useAuth from "../../hooks/useAuth.js/index.js";

import CompanyPaletteSync from "./CompanyPaletteSync";

const AuthContext = createContext();
const AuthProvider = ({ children }) => {
  const value = useAuth();
  return (
    <AuthContext.Provider value={value}>
      <CompanyPaletteSync isAuth={value.isAuth} user={value.user} socket={value.socket} />
      {value.startupError ? (
        <Box role="alert" minHeight="100vh" boxSizing="border-box" display="flex" flexDirection="column"
          alignItems="center" justifyContent="center" bgcolor="background.default" color="text.primary" p={3} textAlign="center">
          <Typography component="h1" variant="h6">Não foi possível abrir o Cchat</Typography>
          <Box my={2}><Typography>{value.startupError}</Typography></Box>
          <Button variant="contained" color="primary" onClick={value.retrySession}>Tentar novamente</Button>
        </Box>
      ) : children}
    </AuthContext.Provider>
  );
};
export { AuthContext, AuthProvider };